<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { setupNotification } from './helper/fcm'

export default {
  mounted () {
    setupNotification()
  }
}
</script>
<style lang="scss">
</style>
